import styled from "styled-components";

export const Container = styled.div`
  padding: 5rem 3rem 5rem 3rem;

  h3 {
    ${(props) => `
      color: ${props.theme.colors.gray};
    `}
    font-size: 1.3rem;
    font-weight: 600;
    margin: 0 0 3rem 0;
  }

  p {
    font-size: 1.4rem;
    line-height: 2.4rem;
  }

  .footer {
    margin-top: 4rem;
  }
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  .switch-label {
    font-size: 1.4rem;
    font-weight: 700;
    margin-right: 1rem;
  }

  .input-switch {
    height: 100%;
  }
  .gray-title {
    color: #8383a9;
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0;
  }
`;

export const Welcome = styled.h1`
  ${(props) => `
    color: ${props.theme.colors.blackTextBody};
  `}
  font-size: 3.2rem;
  font-weight: 800;
  margin-bottom: 1rem;
`;
